// extracted by mini-css-extract-plugin
export var copyableItem = "_49-0";
export var underlined = "_49-1";